//plusButtonPopup.js
import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import ModalDrawer from "../../../components/modal-drawer"; 
import { MembershipOfferForm } from "./membershipOfferForm";
import "../style.scss";

const MOBILE_BREAKPOINT = 768;


const MembershipOfferModal = ({ onClose, onSave, initialData = null }) => {
  const isEditMode = Boolean(initialData);

  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < MOBILE_BREAKPOINT : false
  );

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (isMobile) {
 
    return ReactDOM.createPortal(
      <ModalDrawer
        modalHeader={isEditMode ? "Edit Membership Offer" : "Membership Offer"}
        modalType="membership-offer"
        handleCloseModal={onClose}
        initialData={initialData}
        onSave={onSave}
      />,
      document.body
    );
  }

  const modalContent = (
    <div className="membership-offer-modal-overlay">
      <MembershipOfferForm onClose={onClose} onSave={onSave} initialData={initialData} />
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};

export default MembershipOfferModal;